// ── Real image URLs from Unsplash / public CDNs ──────────────────────────────

export const categories = [
  { id: 1, name: 'Vegetables & Fruits', image: 'https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=100&h=100&fit=crop' },
  { id: 2, name: 'Dairy, Bread & Eggs', image: 'https://images.unsplash.com/photo-1563636619-e9143da7973b?w=100&h=100&fit=crop' },
  { id: 3, name: 'Snack & Munchies', image: 'https://images.unsplash.com/photo-1599490659213-e2b9527bd087?w=100&h=100&fit=crop' },
  { id: 4, name: 'Bakery & Biscuits', image: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=100&h=100&fit=crop' },
  { id: 5, name: 'Instant Food', image: 'https://images.unsplash.com/photo-1612929633738-8fe44f7ec841?w=100&h=100&fit=crop' },
  { id: 6, name: 'Tea, Coffee & Drinks', image: 'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=100&h=100&fit=crop' },
  { id: 7, name: 'Atta, Rice & Dal', image: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=100&h=100&fit=crop' },
  { id: 8, name: 'Baby Care', image: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=100&h=100&fit=crop' },
  { id: 9, name: 'Chicken, Meat & Fish', image: 'https://images.unsplash.com/photo-1604503468506-a8da13d82791?w=100&h=100&fit=crop' },
  { id: 10, name: 'Cleaning Essentials', image: 'https://images.unsplash.com/photo-1585421514284-efb74c2b69ba?w=100&h=100&fit=crop' },
  { id: 11, name: 'Pet Care', image: 'https://images.unsplash.com/photo-1601758174493-45d0a4d3e407?w=100&h=100&fit=crop' },
  { id: 12, name: 'Cold Drinks & Juices', image: 'https://images.unsplash.com/photo-1622483767028-3f66f32aef97?w=100&h=100&fit=crop' },
  { id: 13, name: 'Masala, Oil & More', image: 'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?w=100&h=100&fit=crop' },
  { id: 14, name: 'Personal Care', image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=100&h=100&fit=crop' },
  { id: 15, name: 'Sauces & Spreads', image: 'https://images.unsplash.com/photo-1472476443507-c7a5948772fc?w=100&h=100&fit=crop' },
  { id: 16, name: 'Organic & Gourmet', image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=100&h=100&fit=crop' },
  { id: 17, name: 'Pharma & Wellness', image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=100&h=100&fit=crop' },
  { id: 18, name: 'Home & Office', image: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?w=100&h=100&fit=crop' },
];

export const popularProducts = [
  { id: 1, name: "Haldiram's Sev Bhujia", category: 'Snack & Munchies', price: 18, originalPrice: 24, rating: 4.5, reviews: 149, badge: 'Sale', badgeColor: '#dc2626', image: 'https://images.unsplash.com/photo-1599490659213-e2b9527bd087?w=400&h=400&fit=crop' },
  { id: 2, name: 'Maggi Noodles 2-Min', category: 'Instant Food', price: 24, originalPrice: null, rating: 4.5, reviews: 25, badge: '14%', badgeColor: '#16a34a', image: 'https://rukminim2.flixcart.com/image/416/416/xif0q/noodle/m/o/g/-original-imahj5gc6kk8zkfy.jpeg?q=70&crop=false' },
  { id: 3, name: 'Cadbury 5 Star Chocolate', category: 'Bakery & Biscuits', price: 32, originalPrice: 35, rating: 5, reviews: 469, image: 'https://d2t8nl1y0ie1km.cloudfront.net/images/thumbs/65fa9682d61902ef2307b2f7_Cadbury-5-Star-Chocolate-433gm_1_550.webp' },
  { id: 4, name: 'India Gate Basmati', category: 'Atta, Rice & Dal', price: 150, originalPrice: 180, rating: 3.5, reviews: 456, badge: 'Hot', badgeColor: '#dc2626', image: 'https://m.media-amazon.com/images/I/71eNcsWbRLL.jpg' },
  { id: 5, name: 'Coca Cola ', category: 'Tea, Coffee & Drinks', price: 28, originalPrice: 30, rating: 4.5, reviews: 39, image: 'https://m.media-amazon.com/images/I/41TkNIbZe1L.jpg' },
  { id: 6, name: 'Johnson Baby Soap', category: 'Baby Care', price: 45, originalPrice: 50, rating: 4.5, reviews: 189, badge: 'Sale', badgeColor: '#dc2626', image: 'https://cdn11.bigcommerce.com/s-dmb1ykvg7m/images/stencil/400x400/products/30945/4405/000611__14985.1593673927.jpg?c=2' },
  { id: 7, name: 'Britannia Cheese Slices', category: 'Dairy, Bread & Eggs', price: 145, rating: 5, reviews: 345, image: 'https://img.clevup.in/431278/britannia-cheese-slices-1745046441700_SKU-1707_0.jpg?width=600&format=webp' },
  { id: 8, name: "Chicken Drumsticks", category: 'Chicken, Fish & Meat', price: 250, originalPrice: 280, rating: 4, reviews: 90, image: 'https://thumbs.dreamstime.com/b/fresh-raw-chicken-drumsticks-22866652.jpg' },
  { id: 9, name: 'Tomato', category: 'Vegetables & Fruits', price: 15, originalPrice: 25, rating: 4.5, reviews: 90, image: 'https://media.gettyimages.com/id/1937221560/photo/close-up-of-womans-hand-with-red-tomato-at-the-market.jpg?s=612x612&w=0&k=20&c=Sqe1SxyuYJwW1T4jZq1umhhknAvA7gXpRKWhNFKFINk=' },
  { id: 10, name: 'Pedigree Dog Food', category: 'Pet Care', price: 240, originalPrice: 280, rating: 4.5, reviews: 90, image: 'https://5.imimg.com/data5/XL/YV/MY-28642098/pedigree-adult-chicken-and-veg-1kg-500x500.jpg' },
];

export const dailyDeals = [
  { id: 11, name: 'Roast Ground Coffee', category: 'Tea, Coffee & Drinks', price: 13, originalPrice: 18, rating: 4.5, countdown: '2028/10/10 00:00:00', image: 'https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=300&h=300&fit=crop' },
  { id: 12, name: 'Golden Pineapple', category: 'Fruits & Vegetables', price: 13, originalPrice: 18, rating: 4.5, countdown: '2028/11/11 00:00:00', image: 'https://images.unsplash.com/photo-1550258987-190a2d41a8ba?w=300&h=300&fit=crop' },
  { id: 13, name: 'Amul Butter', category: 'Dairy, Bread & Eggs', price: 99, originalPrice: 280, rating: 4.7, countdown: '2028/12/31 00:00:00', image: 'https://falconfresh.com/media/catalog/product/cache/0e405ab110ef006cccff6c2150b91e32/1/0/10101_3nd.jpg' },
  { id: 14, name: 'Haldiram Sev Bhujia', category: 'Snack & Munchies', price: 18, originalPrice: 24, rating: 4.5, countdown: '2028/09/15 00:00:00', image: 'https://images.unsplash.com/photo-1599490659213-e2b9527bd087?w=400&h=400&fit=crop' },
  { id: 15, name: 'Banana', category: 'Vegetables & Fruits', price: 40, originalPrice: 60, rating: 4.5, countdown: '2028/09/15 00:00:00', image: 'https://images.unsplash.com/photo-1640958900081-7b069dd23e9c?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGJhbmFuYXxlbnwwfHwwfHx8MA==' },

];

const heroSlides = [
  // 🔹 B2B Image Slides
  { bg: '/banners/B2b Grocery webiste.png', type: 'image' },
  { bg: '/banners/hyderabad-grocery.png', type: 'image' },

  // 🔹 Overlay Slides (content style)
  {
    bg: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=1400&h=500&fit=crop',
    type: 'overlay',
    badge: 'Opening Sale Discount 50%',
    title: 'SuperMarket For Fresh Grocery',
    desc: 'Convenient online grocery shopping with fast delivery.',
  },
  {
    bg: 'https://images.unsplash.com/photo-1610348725531-843dff563e2c?w=1400&h=500&fit=crop',
    type: 'overlay',
    badge: 'Free Shipping - orders over ₹100',
    title: 'Free Shipping on orders over ₹100',
    desc: 'Only for first-time customers after discounts.',
  },

  // 🔹 NEW SLIDES (added as you requested)
  {
    bg: 'https://images.unsplash.com/photo-1606787366850-de6330128bfc?w=1400&h=500&fit=crop',
    type: 'overlay',
    badge: 'Daily Essentials',
    title: 'Best Quality Staples & Rice',
    desc: 'Top brands at wholesale prices for your business.',
  },
  {
    bg: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=1400&h=500&fit=crop',
    type: 'overlay',
    badge: 'Snacks Offer',
    title: 'Snacks & Beverages Sale',
    desc: 'Up to 40% OFF on popular snack brands.',
  },
];

export const promoBanners = [
  {
    bg: 'https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=700&h=300&fit=crop',
    title: 'Fruits & Vegetables',
    offer: '30%',
  },
  {
    bg: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=700&h=300&fit=crop',
    title: 'Freshly Baked Buns',
    offer: '25%',
  },
];

export const dealBannerBg = 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=400&h=500&fit=crop';

export const footerCategories = {
  col1: ['Vegetables & Fruits','Breakfast & instant food','Bakery & Biscuits','Atta, rice & dal','Sauces & spreads','Organic & gourmet','Baby care','Cleaning essentials','Personal care'],
  col2: ['Dairy, bread & eggs','Cold drinks & juices','Tea, coffee & drinks','Masala, oil & more','Chicken, meat & fish','Paan corner','Pharma & wellness','Home & office','Pet care'],
};

// ✅ FIXED SECTION
export const locations = [
  { name: 'Arizona', min: '$50' },
  { name: 'California', min: '$29' },
  { name: 'Colorado', min: '$80' },
  { name: 'Florida', min: '$90' },
  { name: 'Georgia', min: '$25' },
  { name: 'Hawaii', min: '$100' },
  { name: 'Idaho', min: '$35' },
  { name: 'Illinois', min: '$45' },
];

export const departments = [
  'Dairy, Bread & Eggs',
  'Snacks & Munchies',
  'Fruits & Vegetables',
  'Cold Drinks & Juices',
  'Breakfast & Instant Food',
  'Bakery & Biscuits',
  'Chicken, Meat & Fish',
];